export var HIDE_FILTER_POPOVER = 'HIDE_FILTER_POPOVER';
export var SHOW_FILTER_POPOVER = 'SHOW_FILTER_POPOVER';
export var REFRESH_FILTER_TYPES = 'REFRESH_FILTER_TYPES';